// Feature Flags Configuration
// This file contains the default feature flag settings
// Override these values by setting environment variables

export const DEFAULT_FEATURE_FLAGS = {
  // Navigation features
  ADMIN_PANEL: true,
  DEPARTMENTS_VIEW: true,
  HOW_TO_PLAY: true,
  SET_PASSWORD: false,

  // Game features
  GAME_TIMER: true,
  GAME_NOTES: false,
  GAME_SUMMARY: false,
  GAME_COUNTDOWN: true,
  FONT_SIZE_ADJUSTER: true,
  USER_STATS: false,

  // Card management features
  CARD_EDITING: true,
  CARD_DELETION: true,
  CARD_BULK_OPERATIONS: true,
  CARD_IMAGES: true,
  DEPARTMENT_MANAGEMENT: true,

  // Authentication features
  ADMIN_AUTH: true,
  GAME_AUTH: true,

  // Development features
  DEBUG_MODE: false,
  ENVIRONMENT_INDICATOR: false,

  // External integrations
  SUPABASE_INTEGRATION: true,
  TINYMCE_EDITOR: true,
};

// Production overrides - set features to false here for production deployment
export const PRODUCTION_OVERRIDES = {
  // Example: Disable admin panel and card deletion for production
  // ADMIN_PANEL: false,
  // CARD_DELETION: false,
  SET_PASSWORD: false, // Always disabled - admin login is integrated into admin panel
};

// Development overrides - enable additional features for development
export const DEVELOPMENT_OVERRIDES = {
  DEBUG_MODE: true,
  ENVIRONMENT_INDICATOR: true,
  DEPARTMENT_MANAGEMENT: true,
};

// Helper function to get feature flags based on environment
export function getFeatureFlags() {
  const isProduction = process.env.NODE_ENV === "production";
  const isDevelopment = process.env.NODE_ENV === "development";

  let flags = { ...DEFAULT_FEATURE_FLAGS };

  // Apply environment-specific overrides
  if (isProduction) {
    flags = { ...flags, ...PRODUCTION_OVERRIDES };
  } else if (isDevelopment) {
    flags = { ...flags, ...DEVELOPMENT_OVERRIDES };
  }

  // Apply environment variable overrides
  Object.keys(flags).forEach((key) => {
    const envKey = `VUE_APP_${key}`;
    if (process.env[envKey] !== undefined) {
      flags[key] = process.env[envKey] === "true";
    }
  });

  return flags;
}
